import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService, ConstantService, HelperService,ApiService } from '../../core/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted: boolean = false;

  constructor(private fb: FormBuilder,
    private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private router: Router,
    private _route: ActivatedRoute,
    private helperSvc: HelperService,) { }

  ngOnInit(): void {

    this.createForm();
  }

  get fc() { return this.loginForm.controls; }

  createForm() {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  loginFormSubmit(){
    // console.log("SUBMIT", this.loginForm.value);
    if(this.loginForm.invalid){
      return;
    }
    // if(this.loginForm.value.username == 'admin' && this.loginForm.value.password == 'admin'){
      // this.router.navigate(['/admin/dashboard']);
    // }
    // this.router.navigate(['/admin/dashboard']);

      this.authSvc.login(this.constantSvc.APIConfig.SIGNIN, this.loginForm.value).subscribe(
      res => {
        if(res.success == true){
          let data = res.user;
          this.helperSvc.notifySuccess("Logged In Succesfully!");
          if(data.role_id == 1){
          this.router.navigate(['/admin/dashboard']);
          }else{
          // this.router.navigate(['/admin/list-of-node']);
          this.router.navigate(['/admin/content']);

          }
        }else{
          this.helperSvc.notifyError(res.msg);
        }
      }, err => {
        // this.helperSvc.notifyError("Error SignIn In!");
      }
    );
  }

}
